import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';

import { theme } from 'helpers/Theme/';
import {
  formatSellerAnalyticsGraphLabels,
  formatSellerAnalyticsGraphValues,
} from 'helpers/formatting';
import { PlotValue } from 'types';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
);

function SellerAnalyticsBarChart({
  data,
  labelText,
}: {
  data: PlotValue[];
  labelText: string;
}) {
  const options: any = {
    responsive: true,
    maintainAspectRatio: false,
    interaction: {
      intersect: false,
      mode: 'index',
    },
    scales: {
      x: {
        ticks: {
          font: {
            size: 8,
          },
        },
      },
      y: {
        ticks: {
          font: {
            size: 10,
          },
        },
      },
    },
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        displayColors: false,
        padding: 8,
        titleFont: {
          size: 12,
        },
        bodyFont: {
          size: 10,
        },
        callbacks: {
          label: function (context: any) {
            let label = context.dataset.label || '';

            if (label) {
              label += ': ';
            }

            if (context.parsed.y !== null) {
              label += `${context.parsed.y} ${labelText}`;
            }
            return label;
          },
        },
      },
    },
  };

  const labels = formatSellerAnalyticsGraphLabels(data);

  const values = formatSellerAnalyticsGraphValues(data);

  const mappedData = {
    labels,
    datasets: [
      {
        data: values,
        backgroundColor: theme.colors.BLUE,
        hoverBackgroundColor: theme.colors.BLUE_DARK,
      },
    ],
  };

  return <Bar data={mappedData} options={options} />;
}

export { SellerAnalyticsBarChart };
